'use strict';

import React, { PropTypes } from 'react';
import ClassNameMixin from '../mixins/ClassNameMixin';
import Icon from '../atoms/Icon';
import MediaActionCreators from '../actions/MediaActionCreators';
import MediaTypes from '../constants/MediaTypes';
import KeyCodes from '../constants/KeyCodes';
import DragItemTypes from '../constants/DragItemTypes';
import EditorSectionMixin from '../mixins/EditorSectionMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';
import createStoreMixin from '../mixins/createStoreMixin';
import StampDraftStore from '../stores/StampDraftStore';
import EditorVideo from './EditorVideo';
import EditorAudio from './EditorAudio';
import Button from '../atoms/Button';
import Loader from '../atoms/Loader';
import DraftActionCreators from '../actions/DraftActionCreators';
import DefaultAudioImage from '../constants/DefaultAudioImage';
import EditorDragImages from '../constants/EditorDragImages';
import getThumbnailUrl from '../utils/getThumbnailUrl';
import { DragDropMixin, ImagePreloaderMixin } from 'react-dnd';
import { find } from 'underscore';
import normalizeUrl from '../utils/normalizeUrl';

import './legacy/Section.less';
import './legacy/EditorMedia.less';

var VIMEO_URL_RE = /^(?:https?:\/\/)?vimeo.com\/(?:.*\/)?(\d+)(?:[\?#].*)?\/?$/i,
    SOUNDCLOUD_URL_RE = /^((?:https?:\/\/)?soundcloud.com\/[^\?#]*)(?:[\?#].*)?\/?$/i;

var EditorMedia = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, EditorSectionMixin, createStoreMixin(StampDraftStore)],

  className: 'editor-Section editor-Section--media',

  propTypes: {
    uuid: PropTypes.string.isRequired,
    section: PropTypes.shape({
      url: PropTypes.string,
      mediaType: PropTypes.oneOf([MediaTypes.VIDEO, MediaTypes.AUDIO_TRACK, MediaTypes.AUDIO_PLAYLIST]),
      background: PropTypes.object
    }).isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    isNew: PropTypes.bool
  },

  getStateFromStores() {
    return {
      isLoadingMedia: StampDraftStore.isLoadingMedia(this.props.section.uuid),
      isLoadingMediaBackground: StampDraftStore.isLoadingMediaBackground(this.props.section.uuid)
    };
  },

  getSectionDragPreviewUrl() {
    var scale = this.getDragImageScale(),
        image;

    switch (this.props.section.mediaType) {
    case MediaTypes.AUDIO_TRACK:
    case MediaTypes.AUDIO_PLAYLIST:
      image = EditorDragImages.AUDIO;
      break;
    case MediaTypes.VIDEO:
      image = EditorDragImages.VIDEO;
      break;
    }

    return getThumbnailUrl(image, {
      mode: 'preview',
      width: Math.round(image.size.width / image.intendedScale * scale),
      height: Math.round(image.size.height / image.intendedScale * scale)
    });
  },

  getImageUrlsToPreload() {
    return [this.getSectionDragPreviewUrl()];
  },

  configureDragDrop(registerType) {
    registerType(DragItemTypes.SECTION, {
      dragSource: this.getSectionDragSource(this.getSectionDragPreviewUrl()),
      dropTarget: this.getSectionDropTarget()
    });
  },

  componentDidMount() {
    if (this.props.isNew) {
      this.getDOMNode().scrollIntoViewIfNeeded();
      if (this.refs.input) {
        this.refs.input.getDOMNode().focus();
      }

      DraftActionCreators.resetLastAddedItem();
    }
  },

  render() {
    var dragSectionState = this.getDragState(DragItemTypes.SECTION);

    return (
      <div className={this.getClassName()}
           data-state={this.props.section.background ? 'background' : 'empty'}
           data-dragging={dragSectionState.isDragging}
           {...this.dropTargetFor(DragItemTypes.SECTION)}>
        <div className='editor-Section-topBar'
             {...this.dragSourceFor(DragItemTypes.SECTION)}>
          {this.renderSectionType()}

          <div className='editor-Section-delete'
               onClick={this.handleDeleteClick}>
            <Icon name='cross' size='xsmall' mode='stroke' />
          </div>

        </div>
        {this.props.section.url ? this.renderMedia() : this.renderInput()}
      </div>
    );
  },

  renderSectionType() {
    switch (this.props.section.mediaType) {
    case MediaTypes.VIDEO:
      return (
        <div className='editor-Section-type'>
          <Icon name='video' size='small' mode='stroke'/>
          <span className='editor-Section-typeTitle'>Video</span>
        </div>
      );

    case MediaTypes.AUDIO_TRACK:
    case MediaTypes.AUDIO_PLAYLIST:
      return (
        <div className='editor-Section-type'>
          <Icon name='audio' size='small' mode='stroke'/>
          <span className='editor-Section-typeTitle'>Audio</span>
        </div>
      );
    }
  },

  renderMedia() {
    var { background, url, title, username, duration, tracks, mediaType, artwork } = this.props.section,
        { isLoadingMedia, isLoadingMediaBackground } = this.state,
        isBackgroundReady = !isLoadingMedia && !isLoadingMediaBackground;

    switch (mediaType) {
    case MediaTypes.VIDEO:
      return (
        <EditorVideo title={title}
                     username={username}
                     duration={duration}
                     background={background}
                     url={url}
                     isBackgroundReady={isBackgroundReady}
                     absoluteCenter />
      );

    case MediaTypes.AUDIO_TRACK:
      return (
        <EditorAudio title={title}
                     username={username}
                     duration={duration}
                     background={background}
                     artwork={artwork || isBackgroundReady && DefaultAudioImage}
                     url={url}
                     isBackgroundReady={isBackgroundReady}
                     absoluteCenter />
      );

    case MediaTypes.AUDIO_PLAYLIST:
      artwork = artwork || (find(tracks, track => !!track.artwork) || {}).artwork;
      return (
        <EditorAudio title={title}
                     username={username}
                     duration={duration}
                     tracks={tracks}
                     background={background}
                     artwork={artwork || isBackgroundReady && DefaultAudioImage}
                     url={url}
                     isBackgroundReady={isBackgroundReady}
                     absoluteCenter />
      );
    }
  },

  renderInput() {
    var { isValidMediaUrl } = this.state,
        placeholder,
        caption,
        logo;

    switch (this.props.section.mediaType) {
    case MediaTypes.VIDEO:
      caption = 'Insert video URL from Vimeo.';
      placeholder = 'http://vimeo.com/example';
      logo = '//stampsy-eu-1.s3.amazonaws.com/2014/10/31/media/vimeo-logo--dark.svg';
      break;

    case MediaTypes.AUDIO_TRACK:
    case MediaTypes.AUDIO_PLAYLIST:
      caption = 'Insert audio track or playlist URL from Soundcloud.';
      placeholder = 'http://soundcloud.com/example';
      logo = '//stampsy-eu-1.s3.amazonaws.com/2014/10/31/media/soundcloud-logo--dark.svg';
      break;
    }

    if (this.state.isLoadingMedia) {
      return <Loader absoluteCenter />;
    }

    return (
      <div className='editor-Section-wrapperBox'>
        <div className='editor-Section-embedLogo'>
          <img className='editor-Section-embedLogoImage' src={logo} />
        </div>
        <div className='editor-Section-embedCaption'>
          {caption}
        </div>
        <div className='editor-Section-embedForm'>
          <input ref='input'
                 className='editor-Section-embedInput'
                 readOnly={this.state.isLoadingMedia}
                 onKeyDown={this.handleInputKeyDown}
                 placeholder={placeholder}
                 onChange={this.handleChange} />
          <Button className='editor-Section-embedSubmit'
                  onClick={this.submitUrl}
                  color='green'
                  size='large'
                  disabled={!isValidMediaUrl}>
            Embed
          </Button>
        </div>
      </div>
    );
  },

  isValidMediaUrl(url) {
    var match = url.trim().match(VIMEO_URL_RE),
        mediaType = this.props.section.mediaType;

    if (match && mediaType === MediaTypes.VIDEO) {
      return true;
    }

    match = url.trim().match(SOUNDCLOUD_URL_RE);
    if (match && (mediaType === MediaTypes.AUDIO_TRACK)) {
      return true;
    }
  },

  handleChange(e) {
    var url = e.target.value;
    this.setState({
      url: url,
      isValidMediaUrl: url && this.isValidMediaUrl(url)
    });
  },

  handleInputKeyDown(e) {
    if (e.which !== KeyCodes.ENTER) {
      return;
    }

    this.submitUrl();
  },

  submitUrl() {
    var url = this.state.url,
        section = this.props.section;

    if (this.isValidMediaUrl(url)) {
      url = normalizeUrl(url.toLowerCase());

      if (url[url.length - 1] === '/') {
        url = url.slice(0, -1);
      }

      MediaActionCreators.requestMediaData(section.uuid, url);
    }
  },

  handleDeleteClick() {
    var section = this.props.section;
    this.props.onDeleteClick(section.uuid, section.url && section.url.length > 0);
  },
});

export default EditorMedia;



/** WEBPACK FOOTER **
 ** ./editor/EditorMedia.jsx
 **/